import { render, staticRenderFns } from "./BarSearch.vue?vue&type=template&id=31923234&scoped=true"
import script from "./BarSearch.vue?vue&type=script&lang=js"
export * from "./BarSearch.vue?vue&type=script&lang=js"
import style0 from "./BarSearch.vue?vue&type=style&index=0&id=31923234&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31923234",
  null
  
)

export default component.exports